'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/choose-a-password-form.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _selectors = require('@marmalade/account/lib/selectors');
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _updateFields = require('@marmalade/form/lib/actions/update-fields');
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _passwordReset = require('@marmalade/form/lib/questions/password-reset');
var _passwordReset2 = _interopRequireDefault(_passwordReset);
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _propTypes = require('@marmalade/prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _girlAtDesk = require('../../images/girl-at-desk.svg');
var _girlAtDesk2 = _interopRequireDefault(_girlAtDesk);
var _actions = require('../actions');
var _constants = require('../constants');
var _selectors2 = require('../selectors');
var _validation = require('../validation');
var _accountPanel = require('./account-panel');
var _accountPanel2 = _interopRequireDefault(_accountPanel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants.forms.choosePassword;
var Centred = _glamorous2.default.div({
  textAlign: 'center'
});
var ChoosePasswordForm = function (_Component) {
  _inherits(ChoosePasswordForm, _Component);
  function ChoosePasswordForm() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, ChoosePasswordForm);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChoosePasswordForm.__proto__ || Object.getPrototypeOf(ChoosePasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (formState) {
      if (formState.validAndPristine) {
        _this.props.setNewPassword(_this.props.product, _this.props.resetId, _this.props.resetToken, formState.values.newPassword);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(ChoosePasswordForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.checkResetHash(this.props.product, this.props.resetId, this.props.resetToken);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetFields(formId, ['newPassword', 'newPasswordConfirm']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        isResetHashValid = _props.isResetHashValid,
        newPasswordHasBeenSet = _props.newPasswordHasBeenSet,
        resetHashError = _props.resetHashError,
        newPasswordError = _props.newPasswordError,
        isRequestingNewPassword = _props.isRequestingNewPassword;
      var icon = newPasswordHasBeenSet ? 'thumbs-up' : 'envelope';
      var title = newPasswordHasBeenSet ? 'Done!' : 'Set password';
      if (resetHashError) {
        return _react2.default.createElement(_accountPanel2.default, {
          img: _girlAtDesk2.default,
          alt: 'Girl at desk',
          icon: icon,
          title: title,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79
          },
          __self: this
        }, _react2.default.createElement(Centred, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 80
          },
          __self: this
        }, _react2.default.createElement('p', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81
          },
          __self: this
        }, resetHashError), _react2.default.createElement(_button.LinkButton, {
          prominence: 'primary',
          block: true,
          to: '/reset-password',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82
          },
          __self: this
        }, 'Request new password set link'), _react2.default.createElement(_reactRouterDom.Link, {
          to: '/login',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 85
          },
          __self: this
        }, 'Go to login page')));
      }

      // Shown while the hash is validating
      if (!isResetHashValid) {
        return _react2.default.createElement(_accountPanel2.default, {
          img: _girlAtDesk2.default,
          alt: 'Girl at desk',
          icon: icon,
          title: title,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 94
          },
          __self: this
        }, _react2.default.createElement(_loading2.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 95
          },
          __self: this
        }));
      }
      return _react2.default.createElement(_accountPanel2.default, {
        img: _girlAtDesk2.default,
        alt: 'Girl at desk',
        icon: icon,
        title: title,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        },
        __self: this
      }, newPasswordHasBeenSet ? _react2.default.createElement(Centred, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104
        },
        __self: this
      }, 'Your password has been successfully set.'), _react2.default.createElement(_button.LinkButton, {
        prominence: 'primary',
        block: true,
        to: this.props.redirect,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105
        },
        __self: this
      }, 'Continue')) : _react2.default.createElement(_form2.default, {
        id: formId,
        handleSubmit: this.handleSubmit,
        validator: _validation.choosePasswordValidator,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        },
        __self: this
      }, newPasswordError ? _react2.default.createElement(_message2.default, {
        type: 'warning',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 111
        },
        __self: this
      }, newPasswordError) : null, _react2.default.createElement(_passwordReset2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 112
        },
        __self: this
      }), _react2.default.createElement(Centred, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        },
        __self: this
      }, isRequestingNewPassword ? _react2.default.createElement(_loading2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: this
      }) : _react2.default.createElement(_button2.default, {
        text: 'Set password',
        type: 'submit',
        prominence: 'primary',
        block: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117
        },
        __self: this
      }))));
    }
  }]);
  return ChoosePasswordForm;
}(_react.Component);
ChoosePasswordForm.propTypes = {
  product: _propTypes.product.isRequired,
  location: _propTypes.location.isRequired,
  setNewPassword: _propTypes2.func.isRequired,
  checkResetHash: _propTypes2.func.isRequired,
  resetFields: _propTypes2.func.isRequired,
  isRequestingNewPassword: _propTypes2.bool.isRequired,
  newPasswordError: _propTypes2.string,
  newPasswordHasBeenSet: _propTypes2.bool.isRequired,
  isResetHashValid: _propTypes2.bool.isRequired,
  resetHashError: _propTypes2.string,
  redirect: _propTypes2.string.isRequired,
  resetId: _propTypes2.string,
  resetToken: _propTypes2.string
};
ChoosePasswordForm.defaultProps = {
  resetId: undefined,
  resetToken: undefined
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    isRequestingNewPassword: (0, _selectors2.isRequestingNewPassword)(state),
    newPasswordError: (0, _selectors2.newPasswordError)(state),
    newPasswordHasBeenSet: (0, _selectors2.newPasswordHasBeenSet)(state),
    isResetHashValid: (0, _selectors.passwordResetHashValid)(state),
    resetHashError: (0, _selectors.passwordResetHashError)(state),
    resetId: state.query.id,
    resetToken: state.query.token
  };
}, {
  setNewPassword: _actions.setNewPassword,
  checkResetHash: _actions.checkResetHash,
  resetFields: _updateFields.resetFields
})(ChoosePasswordForm));